/**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2015, Codrops
 * http://www.codrops.com
 */
// ;(function(window) {

// 	'use strict';

// 	var support = { animations : Modernizr.cssanimations },
// 		animEndEventNames = { 'WebkitAnimation' : 'webkitAnimationEnd', 'OAnimation' : 'oAnimationEnd', 'msAnimation' : 'MSAnimationEnd', 'animation' : 'animationend' },
// 		animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ],
// 		onEndAnimation = function( el, callback ) {
// 			var onEndCallbackFn = function( ev ) {
// 				if( support.animations ) {
// 					if( ev.target != this ) return;
// 					this.removeEventListener( animEndEventName, onEndCallbackFn );
// 				}
// 				if( callback && typeof callback === 'function' ) { callback.call(); }
// 			};
// 			if( support.animations ) {
// 				el.addEventListener( animEndEventName, onEndCallbackFn );
// 			}
// 			else {
// 				onEndCallbackFn();
// 			}
// 		};

// 	// from http://www.sberry.me/articles/javascript-event-throttling-debouncing
// 	function throttle(fn, delay) {
// 		var allowSample = true;

// 		return function(e) {
// 			if (allowSample) {
// 				allowSample = false;
// 				setTimeout(function() { allowSample = true; }, delay);
// 				fn(e);
// 			}
// 		};
// 	}

// 	// sliders - flickity
// 	var sliders = [].slice.call(document.querySelectorAll('.slider')),
// 		// array where the flickity instances are going to be stored
// 		flkties = [],
// 		// grid element
// 		grid = document.querySelector('.grid_collection'),
// 		// isotope instance
// 		iso,
// 		// filter ctrls
// 		filterCtrls = [].slice.call(document.querySelectorAll('.filter > button'));

// 	function init() {
// 		// preload images
// 		imagesLoaded(grid, function() {
// 			initFlickity();
// 			initIsotope();
// 			initEvents();
// 			classie.remove(grid, 'grid--loading');
// 		});
// 	}

// 	function initFlickity() {
// 		sliders.forEach(function(slider){
// 			var flkty = new Flickity(slider, {
// 				prevNextButtons: false,
// 				wrapAround: true,
// 				cellAlign: 'left',
// 				contain: true,
// 				resize: false
// 			});

// 			// store flickity instances
// 			flkties.push(flkty);
// 		});
// 	}

// 	function initIsotope() {
// 		iso = new Isotope( grid, {
// 			isResizeBound: false,
// 			itemSelector: '.grid__item',
// 			percentPosition: true,
// 			masonry: {
// 				// use outer width of grid-sizer for columnWidth
// 				columnWidth: '.grid__sizer'
// 			},
// 			transitionDuration: '0.6s'
// 		});
// 	}

// 	function initEvents() {
// 		filterCtrls.forEach(function(filterCtrl) {
// 			filterCtrl.addEventListener('click', function() {
// 				classie.remove(filterCtrl.parentNode.querySelector('.filter__item--selected'), 'filter__item--selected');
// 				classie.add(filterCtrl, 'filter__item--selected');
// 				iso.arrange({
// 					filter: filterCtrl.getAttribute('data-filter')
// 				});
// 				recalcFlickities();
// 				iso.layout();
// 			});
// 		});

// 		// window resize / recalculate sizes for both flickity and isotope/masonry layouts
// 		window.addEventListener('resize', throttle(function(ev) {
// 			recalcFlickities()
// 			iso.layout();
// 		}, 50));
// 	}

// 	function recalcFlickities() {
// 		for(var i = 0, len = flkties.length; i < len; ++i) {
// 			flkties[i].resize();
// 		}
// 	}

// 	init();

// })(window);


//// Product Preview Slider


jQuery(document).ready(function($) {
	var galleryItems = $('.cd-gallery').children('li');

	galleryItems.each(function(){
		var container = $(this),
			// create slider dots
			sliderDots = createSliderDots(container);
		//check if item is on sale
		updatePrice(container, 0);

		// update slider when user clicks one of the dots
		sliderDots.on('click', function(){
			var selectedDot = $(this);
			if(!selectedDot.hasClass('selected')) {
				var selectedPosition = selectedDot.index(),
					activePosition = container.find('.cd-item-wrapper .selected').index();
				if( activePosition < selectedPosition) {
					nextSlide(container, sliderDots, selectedPosition);
				} else {
					prevSlide(container, sliderDots, selectedPosition);
				}

				updatePrice(container, selectedPosition);
			}
		});

		// update slider on swipeleft
		container.find('.cd-item-wrapper').on('swipeleft', function(){
			var wrapper = $(this);
			if( !wrapper.find('.selected').is(':last-child') ) {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() + 1;
				nextSlide(container, sliderDots);
				updatePrice(container, selectedPosition);
			}
		});

		// update slider on swiperight
		container.find('.cd-item-wrapper').on('swiperight', function(){
			var wrapper = $(this);
			if( !wrapper.find('.selected').is(':first-child') ) {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() - 1;
				prevSlide(container, sliderDots);
				updatePrice(container, selectedPosition);
			}
		});

		// preview image hover effect - desktop only
		container.on('mouseover', '.move-right, .move-left', function(event){
			hoverItem($(this), true);
		});
		container.on('mouseleave', '.move-right, .move-left', function(event){
			hoverItem($(this), false);
		});

		// update slider when user clicks on the preview images
		container.on('click', '.move-right, .move-left', function(event){
			event.preventDefault();
			if ( $(this).hasClass('move-right') ) {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() + 1;
				nextSlide(container, sliderDots);
			} else {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() - 1;
				prevSlide(container, sliderDots);
			}
			updatePrice(container, selectedPosition);
		});
	});

	function createSliderDots(container){
		var dotsWrapper = $('<ol class="cd-dots"></ol>').insertAfter(container.children('.image').children('a'));
		container.find('.cd-item-wrapper li').each(function(index){
			var dotWrapper = (index == 1) ? $('<li class="selected"></li>') : $('<li></li>'),
				dot = $('<a href="#0"></a>').appendTo(dotWrapper);
			dotWrapper.appendTo(dotsWrapper);
			dot.text(index+1);
		});
		return dotsWrapper.children('li');
	}

	function hoverItem(item, bool) {
		( item.hasClass('move-right') )
			? item.toggleClass('hover', bool).siblings('.selected, .move-left').toggleClass('focus-on-right', bool)
			: item.toggleClass('hover', bool).siblings('.selected, .move-right').toggleClass('focus-on-left', bool);
	}

	function nextSlide(container, dots, n){
		var visibleSlide = container.find('.cd-item-wrapper .selected'),
			navigationDot = container.find('.cd-dots .selected');
		if(typeof n === 'undefined') n = visibleSlide.index() + 1;
		visibleSlide.removeClass('selected');
		container.find('.cd-item-wrapper li').eq(n).addClass('selected').removeClass('move-right hover').prevAll().removeClass('move-right move-left focus-on-right').addClass('hide-left').end().prev().removeClass('hide-left').addClass('move-left').end().next().addClass('move-right');
		navigationDot.removeClass('selected')
		dots.eq(n).addClass('selected');
	}

	function prevSlide(container, dots, n){
		var visibleSlide = container.find('.cd-item-wrapper .selected'),
			navigationDot = container.find('.cd-dots .selected');
		if(typeof n === 'undefined') n = visibleSlide.index() - 1;
		visibleSlide.removeClass('selected focus-on-left');
		container.find('.cd-item-wrapper li').eq(n).addClass('selected').removeClass('move-left hide-left hover').nextAll().removeClass('hide-left move-right move-left focus-on-left').end().next().addClass('move-right').end().prev().removeClass('hide-left').addClass('move-left');
		navigationDot.removeClass('selected');
		dots.eq(n).addClass('selected');
	}

	function updatePrice(container, n) {
		var priceTag = container.find('.cd-price'),
			selectedItem = container.find('.cd-item-wrapper li').eq(n);
		if( selectedItem.data('sale') ) { 
			// if item is on sale - cross old price and add new one
// 			priceTag.addClass('on-sale');
// 			var newPriceTag = ( priceTag.next('.cd-new-price').length > 0 ) ? priceTag.next('.cd-new-price') : $('<em class="cd-new-price"></em>').insertAfter(priceTag);
// 			newPriceTag.text(selectedItem.data('price'));
// 			setTimeout(function(){ newPriceTag.addClass('is-visible'); }, 100);
          
//           	Currency.convertAll(Currency.currentCurrency, $("#currencies a.selected").data("currency"), "span.money", "money_format")
		} else {
			// if item is not on sale - remove cross on old price and sale price
			priceTag.removeClass('on-sale').next('.cd-new-price').removeClass('is-visible').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				priceTag.next('.cd-new-price').remove();
			});
		}
	}
});